<template>
  <aside class="md:w-1/4">
    <nav>
      <ul class="flex md:flex-col justify-center md:justify-start space-x-6 md:space-x-0 md:space-y-4 font-inter">
        <li>
          <router-link to="/" class="text-emerald-600 hover:text-emerald-700 transition-colors duration-300 flex items-center space-x-2">
            <span class="hover:translate-x-2 transition-transform duration-300">About</span>
          </router-link>
        </li>
        <!-- <li>
          <router-link to="/ai-radar" class="text-emerald-600 hover:text-emerald-700 transition-colors duration-300 flex items-center space-x-2">
            <i class="fa-solid fa-microchip w-5 text-center"></i>
            <span class="hover:translate-x-2 transition-transform duration-300">AI Radar</span>
          </router-link>
        </li> -->
        <!-- <li>
          <router-link to="/ai-posts" class="text-emerald-600 hover:text-emerald-700 transition-colors duration-300 flex items-center space-x-2">
            <i class="fa-solid fa-timeline w-5 text-center"></i>
            <span class="hover:translate-x-2 transition-transform duration-300">AI Timeline</span>
          </router-link>
        </li> -->
        <li>
          <a href="https://github.com/loginov-kirill" 
            target="_blank" 
            rel="noopener noreferrer" 
            class="text-emerald-600 hover:text-emerald-700 transition-colors duration-300 flex items-center space-x-2">
            <svg class="w-6 h-6 github-icon animate-github-bounce-on-load" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path fill-rule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clip-rule="evenodd"></path>
            </svg>
            <span class="hover:translate-x-2 transition-transform duration-300">Projects</span>
          </a>
        </li>
        <li>
          <a href="https://medium.com/@loginov-kirill" 
            target="_blank" 
            rel="noopener noreferrer" 
            class="text-emerald-600 hover:text-emerald-700 transition-colors duration-300 flex items-center space-x-2">
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M2.846 6.887c.03-.295-.083-.586-.303-.784l-2.24-2.7v-.403h6.958l5.378 11.795 4.728-11.795h6.633v.403l-1.916 1.837c-.165.126-.247.333-.213.538v13.498c-.034.204.048.411.213.537l1.871 1.837v.403h-9.412v-.403l1.939-1.882c.19-.19.19-.246.19-.537v-10.91l-5.389 13.688h-.728l-6.275-13.688v9.174c-.052.385.076.774.347 1.052l2.521 3.058v.404h-7.148v-.404l2.521-3.058c.27-.279.39-.67.325-1.052v-10.608z"/>
            </svg>
            <span class="hover:translate-x-2 transition-transform duration-300">Writing</span>
          </a>
        </li>
      </ul>
    </nav>
  </aside>
</template>

<script>
export default {
  name: "AppSidebar",
}
</script>